import {
  normalizeFilterableSettings,
} from 'core/Filters/util';
import {
  SettingsDTO,
} from 'dtos/settingsDTO';
import {
  getApiSettingsGetChargeFilterSettings,
} from 'endpoints';
import usePrefetchedData from 'pages/Dashboard/hooks/usePrefetchedData';
import {
  getLookupOptions,
} from 'pages/Dashboard/pages/Billing/api';
import {
  UseQueryResult,
  keepPreviousData,
  useQuery,
} from '@tanstack/react-query';

export function useChargesFilterMetaComponents() {
  const { data } = usePrefetchedData<SettingsDTO>({
    key: ['charge-filter-settings'],
    fetchFn: getApiSettingsGetChargeFilterSettings,
  });

  return normalizeFilterableSettings(data?.filterableSettings ?? []);
}

export default function useSearchLookupOptions(
  optionLookupUrl: string,
  searchQuery: string,
  enabled: boolean,
  page?: number,
  pageLimit?: number,
): UseQueryResult<any[], Error> {
  return useQuery<any[], Error>({
    queryKey: ['filter-lookup', optionLookupUrl, searchQuery, page, pageLimit],
    queryFn: () => getLookupOptions(optionLookupUrl, searchQuery, page, pageLimit),
    enabled,
    placeholderData: keepPreviousData,
  });
}
